import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape, ugcVideoShape } from '@bibliocommons/bc-prop-types';
import { ChevronLink } from '@bibliocommons/base-links';
import UgcList from 'app/components/bibs/shared/ugc/UgcList';
import { VideoDisplayContainer } from 'app/components/bibs/shared/ugc/VideoDisplay';
import { VideoEditorContainer } from 'app/components/bibs/shared/ugc/VideoEditor';

import './Videos.scss';

export default function Videos({ videos, currentUserVideos, videosTransactions, summary, bibsActions, catalogBib }) {
  function handleSuccess() {
    const metadataId = catalogBib.get('metadataId');
    bibsActions.fetchUGC(metadataId);
  }

  function renderVideo(video) {
    return <VideoDisplayContainer video={video} catalogBib={catalogBib} handleDeleteSuccess={handleSuccess} />;
  }

  function renderEditor() {
    return (
      !currentUserVideos.get(catalogBib.get('metadataId')) && (
        <VideoEditorContainer metadataId={catalogBib.get('metadataId')} handleSuccess={handleSuccess} />
      )
    );
  }

  const totalVideosCount = summary.getIn(['videos', 'total']);
  const displayedVideosCount = videos.size;

  return (
    <div className="cp-videos" data-key="videos">
      <UgcList
        items={videos}
        catalogBib={catalogBib}
        transactions={videosTransactions}
        renderItem={renderVideo}
        renderEditor={renderEditor}
        contentType="videos"
      />
      {totalVideosCount > displayedVideosCount && (
        <ChevronLink
          className="all-videos"
          href={`/v2/record/${catalogBib.get('metadataId')}/videos`}
          dataKey="all-videos"
        >
          <FormattedMessage id="view_all_videos" values={{ count: totalVideosCount }} />
        </ChevronLink>
      )}
    </div>
  );
}

Videos.propTypes = {
  videos: ImmutablePropTypes.list.isRequired,
  currentUserVideos: ImmutablePropTypes.mapOf(ugcVideoShape).isRequired,
  videosTransactions: ImmutablePropTypes.map.isRequired,
  summary: ImmutablePropTypes.map.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  catalogBib: catalogBibShape.isRequired
};
